import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FaqItem from './FaqItem';
import { localizations } from '../../localization/localization';

const styles = (theme: Theme) => createStyles({
  newFeaturesContainer: {
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    padding: '2.25em',
    paddingTop: '1.75em',
    paddingBottom: '2.4375em',
    marginTop: '4.375em',
    marginBottom: '4.25em',
  },
  newFeaturesContainerMobile: {
    maxWidth: 448,
    display: 'flex',
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    padding: '2.0625em',
    marginBottom: '4.25em',
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginTop: '1.2941em',
      marginBottom: '0.7em'
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'inherit'
    }
  },
  newFeatureBox: {
    paddingTop: '0.0625em',
    paddingBottom: '0.0625em',
    paddingLeft: '2.25em',
    paddingRight: '2.25em',
    flex: 1,
    '& > div:first-child': {
      color: 'white',
      fontSize: '1.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginTop: '1.2941em',
      marginBottom: '0.7em'
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'inherit'
    }
  },
  newFeatureBoxMobile: {
    paddingTop: '0.0625em',
    paddingBottom: '0.0625em',
    flex: 1,
    '& > div:first-child': {
      color: 'white',
      fontSize: '1.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginTop: '1.2941em',
      marginBottom: '0.7em'
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'inherit'
    }
  },
  title: {
    fontSize: '2.125em',
    fontWeight: 'bold',
    letterSpacing: '0.0358em',
    lineHeight: 1.353,
    color: 'white'
  },
  newFeaturesInnerContainer: {
    display: 'flex',
  },
  newFeaturesInnerContainerMobile: {
    display: 'flex',
    alignItems: "center"
  },
  hidden: {
    display: 'none'
  },
  nobull: {
    listStyleType: 'none'
   },
   link: {
     color: theme.palette.secondary.main,
     cursor: 'pointer',
     textDecoration: 'underline'
   },
});

interface MobileViewProps {
  isMobileDevice: boolean | undefined;
}

type Props = MobileViewProps

class NewFeaturesContainer extends React.Component<WithStyles & Props> {
  constructor(props: WithStyles & Props) {
    super(props);
  }

  public render() {
    const { classes } = this.props;
    return (
      <Grid item container direction="column" alignItems="center" className={this.props.isMobileDevice === false ? classes.newFeaturesContainer : classes.newFeaturesContainerMobile}>
        <Grid item className={classes.title}>{localizations.landingPageView.newFeatures.title}</Grid>
        <Grid item container className={this.props.isMobileDevice === false ? classes.newFeatureBox : classes.newFeatureBoxMobile}>
          <Grid item>{localizations.landingPageView.newFeatures.title5}</Grid>
          <Grid item>{localizations.landingPageView.newFeatures.content5}</Grid>
        </Grid>
        <Grid item container className={this.props.isMobileDevice === false ? classes.newFeatureBox : classes.newFeatureBoxMobile}>
          <Grid item>{localizations.landingPageView.newFeatures.title6}</Grid>
          <Grid item>{localizations.landingPageView.newFeatures.content6}</Grid>
        </Grid>
        <Grid item container className={this.props.isMobileDevice === false ? classes.newFeatureBox : classes.newFeatureBoxMobile}>
          <Grid item>{localizations.landingPageView.newFeatures.title1}</Grid>
          <Grid item>{localizations.landingPageView.newFeatures.content1}</Grid>
        </Grid>
        <Grid item container className={this.props.isMobileDevice === false ? classes.newFeatureBox : classes.newFeatureBoxMobile}>
          <Grid item>{localizations.landingPageView.newFeatures.title2}</Grid>
          <Grid item>{localizations.landingPageView.newFeatures.content2a} <a href="https://zeckit.com/fi/mika-zeckit/mika-zeckit-selvitys/" className={classes.link}>Zeckit</a> {localizations.landingPageView.newFeatures.content2b}</Grid>
        </Grid>
        <Grid item container className={this.props.isMobileDevice === false ? classes.newFeatureBox : classes.newFeatureBoxMobile}>
          <Grid item>{localizations.landingPageView.newFeatures.title3}</Grid>
          <Grid item>{localizations.landingPageView.newFeatures.content3}</Grid>
        </Grid>
        <Grid item container direction="column" className={this.props.isMobileDevice === false ? classes.newFeatureBox : classes.newFeatureBoxMobile}>
          <Grid item>{localizations.landingPageView.newFeatures.title4}</Grid>
          <Grid item>{localizations.landingPageView.newFeatures.content4}</Grid>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(NewFeaturesContainer);



// WEBPACK FOOTER //
// ./src/landingPage/components/NewFeaturesContainer.tsx